import React, { useState, useEffect } from 'react';
import './App.css';
import { socket } from './socket';
import CustomTerminal from './CustomTerminal';
import moment from 'moment'

export default function App(props) {

  const [input, setInput] = useState('');
  const [inputDisabled, setInputDisabled] = useState(false);

  const [linesToPrint, setLinesToPrint] = useState('');

  const [timestampActivado, setTimestampActivado] = useState(false);

  const [userID, setUserID] = useState(undefined);
  const [nombreJugador, setNombreJugador] = useState(undefined);

  function getTimestamp() {
    var timestampActivado = sessionStorage.getItem('timestampActivado') === "true";
    console.log("TIMESTAMP ACTIVADO? ", timestampActivado)
    if (!timestampActivado) {
      return '';
    }

    // Obtener la hora actual en GMT
    const horaActualGMT = moment.utc();

    // Convertir la hora actual de GMT a GMT-3
    const horaActualGMTMenos3 = horaActualGMT.utcOffset('-03:00');

    // Formatear la hora en GMT-3 como cadena de texto
    const horaFormateadaGMTMenos3 = horaActualGMTMenos3.format('HH:mm:ss'); // Quito ms .SSS

    console.log('Hora actual GMT:', horaActualGMT.format('HH:mm:ss')); // Quito ms .SSS
    console.log('Hora actual GMT-3:', horaFormateadaGMTMenos3);

    return '[' + horaFormateadaGMTMenos3 + '] ';
  }

  function resolvePlayerStartedShootingWithAnotherPlayer(attackerId, victimId, attackerWon, attackerName, victimName) {

    let response = getTimestamp() + attackerName + ' (ID ' + attackerId + ')' + ' empezó un tiroteo con '+victimName+' (ID ' + victimId + ").\n\n";

    if (attackerWon) {
      response += 'Jugador ID ' + attackerId + ' mató a Jugador ID ' + victimId + ".\n\n"
    } else {
      response += 'Jugador ID ' + victimId + ' mató a Jugador ID ' + attackerId + ".\n\n"
    }

    return response;
  }

  function resolvePlayerStartedShootingWithAnotherPlayerAfterRetener(attackerId, victimId, attackerWon, weapon, attackerName, victimName) {

    let response = getTimestamp() + attackerName + ' (ID ' + attackerId + ')' + ' intenta retener a '+victimName+' (ID ' + victimId + ") con " + weapon + " y este responde a los tiros.\n\n";

    if (attackerWon) {
      response += attackerName + ' (ID ' + attackerId + ')' + ' mató a '+victimName+' (ID ' + victimId + ").\n\n"
    } else {
      response += victimName + ' (ID ' + victimId + ')' + ' mató a '+attackerName+' (ID ' + attackerId + ").\n\n"
    }

    return response;
  }

  useEffect(() => {
    function onConnect() {
      console.log("Socket connected to Node server.")
    }

    function onDisconnect(event) {
      console.log("Socket disconnected to Node server.")

      console.log("EVENT! ", event)

      if (event === "io client disconnect") {
        console.log("DESCONEXION DE MUERTE, BACKEND TRIGGER")
      }

      // Desconexion forzada, cuando cae el server.
      if (event === "transport close" || event === "ping timeout") {

        if (event === "transport close") {
          setLinesToPrint('Hubo un error de conexión con el servidor. Refrescá la página (F5) para entrar denuevo.');
        }
        if (event === "ping timeout") {
          setLinesToPrint('Perdiste conexión con el servidor por 15 segundos y fuiste desconectado. Refrescá la página (F5) para entrar denuevo.');
        }

        socket.disconnect(false, userID); // disconnectFromDeath = false

        setInputDisabled(true);

      }

    }

    socket.on('connect', onConnect);
    socket.on('disconnect', onDisconnect);

    setLinesToPrint('----------------------------------------------\n\n' + 'Conurbano Stories. Juego de texto multijugador' + '\n\n----------------------------------------------\n\n' + '\n\nEscribí el comando -login USUARIO CONTRASEÑA- para ingresar o registrarte e ingresar automáticamente. Ejemplo: login usuario 1234\n');

    const username = sessionStorage.getItem('username');
    const password = sessionStorage.getItem('password');

    if (username != null && password != null) {
      socket.emit('login', username + ' ' + password)
    }

    socket.on('initialRoomData', function (initialRoomData) {
      console.log("initialRoomData \n", initialRoomData);

      const username = sessionStorage.getItem('username');
      const password = sessionStorage.getItem('password');

      if (!username || !password) {
        console.log("initialRoomData.nombre ", initialRoomData.nombre)
        sessionStorage.setItem('username', initialRoomData.nombre);

        console.log("initialRoomData.password ", initialRoomData.password)
        sessionStorage.setItem('password', initialRoomData.password);
      }

      setUserID(initialRoomData.userID)
      setNombreJugador(initialRoomData.nombre)
      setLinesToPrint(initialRoomData.linesToPrint);
    });

    socket.on('invalidPassword', function (data) {
      console.log("invalidPassword \n", data);
      setLinesToPrint(data.msg);
    });

    socket.on('invalidUserOrPasswordFormat', function (data) {
      console.log("invalidUserOrPasswordFormat \n", data);
      setLinesToPrint(data.msg);
    });

    socket.on('newPlayerInRoom', function (socketId, nombre) {
      console.log("newPlayerInRoom \n", socketId);
      setLinesToPrint(getTimestamp() + nombre + ' (ID ' + socketId + ') aparece en el lugar.');
    });

    socket.on('playerLeftRoom', function (socketId, direccion, nombre) {
      console.log("playerLeftRoom \n", socketId, direccion);
      setLinesToPrint(getTimestamp() + nombre + ' (ID ' + socketId + ') se va del lugar en dirección ' + direccion + '.');
    });

    socket.on('pickedUpItemMessage', function (response) {
      console.log("pickedUpItemMessage \n", response);
      setLinesToPrint(getTimestamp() + response.nombre + ' (ID ' + response.socketId + ') agarra ' + response.item + '.');
    });

    socket.on('playerSavedItemMessage', function (response) {
      console.log("playerSavedItemMessage \n", response);
      setLinesToPrint(getTimestamp() + response.nombre + ' (ID ' + response.socketId + ') guarda ' + response.item + ' en su inventario.');
    });

    socket.on('playerSavedItemInContainer', function (response) {
      console.log("playerSavedItemInContainer \n", response);
      setLinesToPrint(getTimestamp() + response.nombre + ' (ID ' + response.socketId + ') guarda ' + response.item + ' en el cofre ID ' + response.cofreId + '.');
    });

    socket.on('playerTakesItemFromContainer', function (response) {
      console.log("playerTakesItemFromContainer \n", response);
      setLinesToPrint(getTimestamp() + response.nombre + ' (ID ' + response.socketId + ') saca ' + response.item + ' del cofre ID ' + response.cofreId + '.');
    });

    socket.on('playerThrewItemMessage', function (response) {
      console.log("playerThrewItemMessage \n", response);
      setLinesToPrint(getTimestamp() + response.nombre + ' (ID ' + response.socketId + ') tira ' + response.item + ' al piso.');
    });

    socket.on('playerPulledItemMessage', function (response) {
      console.log("playerPulledItemMessage \n", response);
      setLinesToPrint(getTimestamp() + response.nombre + ' (ID ' + response.socketId + ') saca ' + response.item + ' de su inventario.');
    });

    socket.on('playerGaveItemMessage', function (response) {
      console.log("playerGaveItemMessage \n", response);
      setLinesToPrint(getTimestamp() + response.giverName + ' (ID ' + response.giverId + ') le da ' + response.item + ' a ' + response.receiverName + ' (ID ' + response.receiverId + ').');
    });

    socket.on('receivedItemMessage', function (response) {
      console.log("receivedItemMessage \n", response);
      setLinesToPrint(getTimestamp() + response.giverName + ' (ID ' + response.giverId + ') te da ' + response.item + ".");
    });

    socket.on('playerShotAnotherPlayer', function (response) {
      console.log("playerShotAnotherPlayer \n", response);
      setLinesToPrint(getTimestamp() + response.attackerName + ' (ID ' + response.attackerId + ') le dispara a ' + response.victimName + " (ID " + response.victimId + ") con " + response.weapon + ". Este último muere al instante." + " (Cadáver ID " + response.cadaverId + ")");
    });

    socket.on('playerShotAnotherEscapingPlayer', function (response) {
      console.log("playerShotAnotherEscapingPlayer \n", response);
      setLinesToPrint(getTimestamp() + response.victimName + " (ID " + response.victimId + ") intenta escapar y " + response.attackerName + " (ID " + response.attackerId + ") le dispara con " + response.weapon + ". Muere al instante." + " (Cadáver ID " + response.cadaverId + ")");
    });

    socket.on('playerSuicided', function (response) {
      console.log("playerSuicided \n", response);
      setLinesToPrint(getTimestamp() + response.attackerName + ' (ID ' + response.attackerId + ') se dispara a sí mismo en la sien con ' + response.weapon + '. Muere al instante.' + " (Cadáver ID " + response.cadaverId + ")");
    });

    socket.on('youShotAnotherPlayerEscaping', function (response) {
      console.log("youShotAnotherPlayerEscaping \n", response);
      setLinesToPrint(getTimestamp() + response.victimName + " (ID " + response.victimId + ") intenta escapar y le disparás con " + response.weapon + ". Murió.");
    });

    socket.on('playerRetainedAnotherPlayer', function (response) {
      console.log("playerRetainedAnotherPlayer \n", response);
      setLinesToPrint(getTimestamp() + response.attackerName + ' (ID ' + response.attackerId + ') apunta con su Revolver y retiene a ' + response.victimName + ' (ID ' + response.victimId + ').');
    });

    socket.on('playerCreatedContainer', function (response) {
      console.log("playerCreatedContainer \n", response);
      setLinesToPrint(getTimestamp() + response.playerName + ' (ID ' + response.playerId + ') fabrica un cofre de madera. (ID ' + response.cofreId + ') ');
    });

    socket.on('playerInstalledGenerator', function (response) {
      console.log("playerInstalledGenerator \n", response);
      setLinesToPrint(getTimestamp() + response.playerName + ' (ID ' + response.playerId + ') conecta un Generador al sistema eléctrico de la casa.');
    });

    socket.on('ruido', function (response) {
      console.log("ruido \n", response);
      setLinesToPrint(getTimestamp() + response.msg);
    });

    socket.on('playerReadsBook', function (response) {
      console.log("playerReadsBook \n", response);
      setLinesToPrint(getTimestamp() + response.playerName + ' (ID ' + response.playerId + ') lee '+response.book+'.');
    });

    socket.on('playerUninstalledGenerator', function (response) {
      console.log("playerUninstalledGenerator \n", response);
      setLinesToPrint(getTimestamp() + response.playerName + ' (ID ' + response.playerId + ') desconecta el Generador del sistema eléctrico de la casa y lo agarra.');
    });

    socket.on('playerInspectGenerator', function (response) {
      console.log("playerInspectGenerator \n", response);
      setLinesToPrint(getTimestamp() + response.playerName + ' (ID ' + response.playerId + ') revisa el Generador eléctrico conectado a la casa.');
    });

    socket.on('playerStartedGenerator', function (response) {
      console.log("playerStartedGenerator \n", response);
      setLinesToPrint(getTimestamp() + response.playerName + ' (ID ' + response.playerId + ') prende el Generador eléctrico tocando un botón en el mismo. Se prenden las luces de la casa.');
    });

    socket.on('playerStoppedGenerator', function (response) {
      console.log("playerStoppedGenerator \n", response);
      setLinesToPrint(getTimestamp() + response.playerName + ' (ID ' + response.playerId + ') apaga el Generador eléctrico tocando un botón en el mismo. Se apagan las luces de la casa.');
    });

    socket.on('playerFillsGenerator', function (response) {
      console.log("playerFillsGenerator \n", response);
      setLinesToPrint(getTimestamp() + response.playerName + ' (ID ' + response.playerId + ') carga de combustible el Generador eléctrico con su Bidon de nafta.');
    });

    socket.on('playerForcedContainer', function (response) {
      console.log("playerForcedContainer \n", response);
      setLinesToPrint(getTimestamp() + response.playerName + ' (ID ' + response.playerId + ') fuerza la cerradura del cofre de madera ID ' + response.cofreId + '.');
    });

    socket.on('playerOpenedContainer', function (response) {
      console.log("playerOpenedContainer \n", response);
      setLinesToPrint(getTimestamp() + response.playerName + ' (ID ' + response.playerId + ') abre el cofre de madera ID ' + response.cofreId + '.');
    });

    socket.on('playerCheckedOpenContainer', function (response) {
      console.log("playerCheckedOpenContainer \n", response);
      setLinesToPrint(getTimestamp() + response.playerName + ' (ID ' + response.playerId + ') revisa el contenido del cofre de madera ID ' + response.cofreId + '.');
    });

    socket.on('playerClosedContainer', function (response) {
      console.log("playerClosedContainer \n", response);
      setLinesToPrint(getTimestamp() + response.playerName + ' (ID ' + response.playerId + ') cierra el cofre de madera ID ' + response.cofreId + '.');
    });

    socket.on('playerCheckedDeadBody', function (response) {
      console.log("playerCheckedDeadBody \n", response);
      setLinesToPrint(getTimestamp() + response.checkerName + ' (ID ' + response.checkerId + ') revisa el cadáver de Jugador ID ' + response.bodyId + ".");
    });

    socket.on('playerStoleFromDeadBody', function (response) {
      console.log("playerStoleFromDeadBody \n", response);
      setLinesToPrint(getTimestamp() + response.stealerName + ' (ID ' + response.stealerId + ') le quita ' + response.item + ' al cadáver de Jugador ID ' + response.bodyId + ".");
    });

    socket.on('playerDiedFromHunger', function (response) {
      console.log("playerDiedFromHunger \n", response);
      setLinesToPrint(getTimestamp() + response.deadName + ' (ID ' + response.deadId + ') murió de hambre.');
    });

    socket.on('playerDiedFromThirst', function (response) {
      console.log("playerDiedFromThirst \n", response);
      setLinesToPrint(getTimestamp() + response.deadName + ' (ID ' + response.deadId + ') murió de sed.');
    });

    socket.on('playerOpenedDoor', function (response) {
      console.log("playerOpenedDoor \n", response);
      setLinesToPrint(getTimestamp() + response.playerName + ' (ID ' + response.playerId + ') abre una puerta con Llave en dirección ' + response.direccion + '.');
    });

    socket.on('playerClosedDoor', function (response) {
      console.log("playerClosedDoor \n", response);
      setLinesToPrint(getTimestamp() + response.playerName + ' (ID ' + response.playerId + ') cierra una puerta con Llave en dirección ' + response.direccion + '.');
    });

    socket.on('playerForcedDoor', function (response) {
      console.log("playerForcedDoor \n", response);
      setLinesToPrint(getTimestamp() + response.playerName + ' (ID ' + response.playerId + ') fuerza una puerta con Barreta en dirección ' + response.direccion + '.');
    });

    socket.on('someoneForcedDoor', function (response) {
      console.log("someoneForcedDoor \n", response);
      setLinesToPrint(getTimestamp() + 'Se escucha un fuerte golpe proveniente de la puerta en dirección ' + response.direccion + '.');
    });

    socket.on('playerAteFood', function (response) {
      console.log("playerAteFood \n", response);
      setLinesToPrint(getTimestamp() + response.playerName + ' (ID ' + response.playerId + ') come ' + response.food + '.');
    });

    socket.on('playerConsultaHora', function (response) {
      console.log("playerConsultaHora \n", response);
      setLinesToPrint(getTimestamp() + response.playerName + ' (ID ' + response.playerId + ') revisa la hora en su reloj.');
    });

    socket.on('playerDrankBeverage', function (response) {
      console.log("playerDrankBeverage \n", response);
      setLinesToPrint(getTimestamp() + response.playerName + ' (ID ' + response.playerId + ') bebe ' + response.drink + '.');
    });

    socket.on('playerStartedShootingWithAnotherPlayer', function (response) {
      console.log("playerStartedShootingWithAnotherPlayer \n", response);
      setLinesToPrint(resolvePlayerStartedShootingWithAnotherPlayer(response.attackerId, response.victimId, response.attackerWon));
    });

    socket.on('playerStartedShootingWithAnotherPlayerAfterRetener', function (response) {
      console.log("playerStartedShootingWithAnotherPlayer \n", response);
      setLinesToPrint(resolvePlayerStartedShootingWithAnotherPlayerAfterRetener(response.attackerId, response.victimId, response.attackerWon, response.weapon));
    });

    socket.on('receivedShot', function (response) {
      console.log("receivedShot \n", response);

      setLinesToPrint(getTimestamp() + response.attackerName + ' (ID ' + response.attackerId + ') te dispara con ' + response.weapon + ". \n\nMoriste..." + " (Cadáver ID " + response.cadaverId + ")" + "\n\n\nRefrescá la página (F5) para empezar denuevo.");

      socket.disconnect(true, userID); // disconnectFromDeath = true

      setInputDisabled(true);
    });

    socket.on('receivedShotEscaping', function (response) {
      console.log("receivedShotEscaping \n", response);

      setLinesToPrint(getTimestamp() + 'Intentás escapar y ' + response.attackerName + ' (ID ' + response.attackerId + ') te dispara con ' + response.weapon + ". \n\nMoriste..." + " (Cadáver ID " + response.cadaverId + ")" + "\n\n\nRefrescá la página (F5) para empezar denuevo.");

      socket.disconnect(true, userID); // disconnectFromDeath = true

      setInputDisabled(true);
    });

    socket.on('youSuicided', function (response) {
      console.log("youSuicided \n", response);

      setLinesToPrint(getTimestamp() + 'Te disparás a vos mismo en la sien con ' + response.weapon + ". \n\nMoriste..." + " (Cadáver ID " + response.cadaverId + ")" + "\n\n\nRefrescá la página (F5) para empezar denuevo.");

      socket.disconnect(true, userID); // disconnectFromDeath = true

      setInputDisabled(true);
    });

    socket.on('beingRetained', function (response) {
      console.log("beingRetained \n", response);

      setLinesToPrint(getTimestamp() + response.attackerName + ' (ID ' + response.attackerId + ') te apunta con ' + response.weapon + " y te retiene.");
    });

    socket.on('hungerDeath', function (response) {
      console.log("hungerDeath \n", response);

      setLinesToPrint(getTimestamp() + 'Moriste de hambre...\n\n\nRefrescá la página (F5) para empezar denuevo.');

      socket.disconnect(true, userID); // disconnectFromDeath = true

      setInputDisabled(true);
    });

    socket.on('thirstDeath', function (response) {
      console.log("thirstDeath \n", response);

      setLinesToPrint(getTimestamp() + 'Moriste de sed...\n\n\nRefrescá la página (F5) para empezar denuevo.');

      socket.disconnect(true, userID); // disconnectFromDeath = true

      setInputDisabled(true);
    });

    socket.on('hungerStatus', function (response) {
      console.log("hungerStatus \n", response);

      setLinesToPrint(getTimestamp() + response);
    });

    socket.on('thirstStatus', function (response) {
      console.log("thirstStatus \n", response);

      setLinesToPrint(getTimestamp() + response);
    });

    socket.on('dayNightStatus', function (response) {
      console.log("dayNightStatus \n", response);

      setLinesToPrint(getTimestamp() + response);
    });

    socket.on('rainStatus', function (response) {
      console.log("rainStatus \n", response);

      setLinesToPrint(getTimestamp() + response);
    });

    socket.on('rayoStatus', function (response) {
      console.log("rayoStatus \n", response);

      setLinesToPrint(getTimestamp() + response);
    });

    socket.on('receivedShooting', function (response) {
      console.log("receivedShooting \n", response);

      setLinesToPrint(
        response.shootingStarter === response.winnerId ?
          (getTimestamp() + response.shootingStarterName + ' (ID ' + response.shootingStarter + ') empieza a tirotearte y respondés de la misma manera.\n')
          :
          (getTimestamp() + 'Empezás un tiroteo con ' + response.winnerName + ' (ID ' + response.winnerId + ') y este responde de la misma manera.\n')
      );
    });

    socket.on('receivedShootingAfterRetener', function (response) {
      console.log("receivedShootingAfterRetener \n", response);

      setLinesToPrint(
        response.shootingStarter === response.winnerId ?
          (getTimestamp() + response.shootingStarterName + ' (ID ' + response.shootingStarter + ') empieza a tirotearte y respondés de la misma manera.\n')
          :
          (getTimestamp() + 'Intentás retener a ' + response.winnerName + ' (ID ' + response.winnerId + ') y este responde a los tiros.\n')
      );
    });

    socket.on('victimReceivedShooting', function (response) {
      console.log("victimReceivedShooting \n", response);

      let shootingStarted = response.shooterName + ' (ID ' + response.shooterId + ') empieza a tirotearte y respondés de la misma manera.\n\n';

      setLinesToPrint(getTimestamp() + shootingStarted + response.shooterName + ' (ID ' + response.shooterId + ') te dispara con ' + response.weapon + ". \n\nMoriste..." + " (Cadáver ID " + response.cadaverId + ")" + "\n\n\nRefrescá la página (F5) para empezar denuevo.");

      socket.disconnect(true, userID); // disconnectFromDeath = true

      setInputDisabled(true);

    });

    socket.on('victimReceivedShootingAfterRetener', function (response) {
      console.log("victimReceivedShootingAfterRetener \n", response);

      let shootingStarted = response.shooterName + ' (ID ' + response.shooterId + ') intenta retenerte y respondés a los tiros.\n\n';

      setLinesToPrint(getTimestamp() + shootingStarted + response.shooterName + ' (ID ' + response.shooterId + ') te dispara con ' + response.weapon + ". \n\nMoriste..." + " (Cadáver ID " + response.cadaverId + ")" + "\n\n\nRefrescá la página (F5) para empezar denuevo.");

      socket.disconnect(true, userID); // disconnectFromDeath = true

      setInputDisabled(true);

    });

    socket.on('notifyShootingVictimThatWon', function (response) {
      console.log("notifyShootingVictimThatWon \n", response);

      setLinesToPrint(
        getTimestamp() + response.attackerName + ' (ID ' + response.attackerId + ') empieza a tirotearte y respondés de la misma manera.\n\n\n' + 'Mataste a ' + response.attackerName + ' (ID ' + response.attackerId + ').');
    });

    socket.on('notifyRetenerVictimThatWon', function (response) {
      console.log("notifyRetenerVictimThatWon \n", response);

      setLinesToPrint(
        getTimestamp() + response.attackerName + ' (ID ' + response.attackerId + ') intenta retenerte y respondés a los tiros.\n\n\n' + 'Mataste a Jugador ID ' + response.attackerId + '.');
    });

    socket.on('setChatMessage', function (response) {
      console.log("setChatMessage \n", response);
      setLinesToPrint(getTimestamp() + response.nombre + ' (ID ' + response.socketId + ') dice: ' + response.msg);
    });

    socket.on('playerLiberado', function (response) {
      console.log("playerLiberado \n", response);
      setLinesToPrint(getTimestamp() + response.attackerName + ' (ID ' + response.attackerId + ') deja de apuntarte con su ' + response.weapon + '.');
    });

    socket.on('playerLiberarNotification', function (response) {
      console.log("playerLiberarNotification \n", response);
      setLinesToPrint(getTimestamp() + response.attackerName + ' (ID ' + response.attackerId + ') deja de apuntar con su ' + response.weapon + ' a ' + response.victimName + ' (ID ' + response.victimId + ').');
    });

    socket.on('setSusurroMessage', function (response) {
      console.log("setSusurroMessage \n", response);
      setLinesToPrint(getTimestamp() + response.emisorNombre + ' (ID ' + response.emisorId + ') te susurra: ' + response.msg);
    });

    socket.on('setSusurroMessageAllPlayers', function (response) {
      console.log("setSusurroMessageAllPlayers \n", response);
      setLinesToPrint(getTimestamp() + response.emisorNombre + ' (ID ' + response.emisorId + ') le susurra algo a '+ response.receptorNombre + ' (ID ' + response.receptorId + ').');
    });

    socket.on('radioMessage', function (response) {
      setLinesToPrint(getTimestamp() + '[Radio - Frecuencia ' + response.freq + '] ' + response.nombre + ' (ID ' + response.socketId + '): ' + response.msg);
    });

    socket.on('radioSystemMessage', function (response) {
      setLinesToPrint(getTimestamp() + response.msg);
    });

    socket.on('estresStatus', function (response) {
      setLinesToPrint(getTimestamp() + response);
    });

    socket.on('playerFuma', function (response) {
      setLinesToPrint(getTimestamp() + response.playerName + ' (ID ' + response.playerId + ') enciende un cigarrillo y fuma.');
    });

    socket.on('setRolMessage', function (response) {
      console.log("setRolMessage \n", response);
      setLinesToPrint(getTimestamp() + '(Rol) ' + response.nombre + ' (ID ' + response.socketId + ') ' + response.msg);
    });

    socket.on('setEnvMessage', function
      (response) {
      console.log("setEnvMessage \n", response);
      setLinesToPrint(getTimestamp() + response.msg + '.' + ' ('+response.nombre+'. ID ' + response.socketId + ')');
    });

    socket.on('playerDisconnect', function (response) {
      console.log("playerDisconnect \n", response);
      setLinesToPrint(getTimestamp() + response.nombre + ' (ID ' + response.socketId + ') se desconectó.');
    });

    socket.on('playerDisconnectTimeout', function (response) {
      console.log("playerDisconnectTimeout \n", response);
      setLinesToPrint(getTimestamp() + response.nombre + ' (ID ' + response.socketId + ') perdió conexión con el servidor.');
    });

    return () => {
      socket.off('connect', onConnect);
      socket.off('disconnect', onDisconnect);
    };
  }, []);

  function inspeccionar() {

    let currentRoomData = "";
    currentRoomData = new Promise((resolve, reject) => {
      socket.emit("getCurrentRoomData", (response) => {
        console.log("currentRoomDataResponse", response)

        console.log("RESPONSE CURRENTROOM: ", response.response + "\n\n" + response.userList)
        let responseMsg = "";
        if (response.userList != "") {
          responseMsg = response.response + "\n\n" + response.userList
        } else {
          responseMsg = response.response

        }
        resolve(response.response);
      });
    });

    console.log("currentRoomData", currentRoomData)
    return currentRoomData;
  }

  function resolverDireccion(direccion) {

    let responseMsg = "";
    responseMsg = new Promise((resolve, reject) => {
      socket.emit("resolverDireccion", direccion, (response) => {
        console.log("resolverDireccionResponse", response)
        resolve(response);
      });
    });

    console.log("resolverDireccion response: ", responseMsg)
    return responseMsg;
  }

  function mostrarInventario() {

    let responseMsg = "";
    responseMsg = new Promise((resolve, reject) => {
      socket.emit("getInventario", (response) => {
        console.log("getInventarioResponse", response)
        resolve(response);
      });
    });

    console.log("getInventario response: ", responseMsg)
    return responseMsg;
  }

  function agarrarItem(item) {

    let responseMsg = "";
    responseMsg = new Promise((resolve, reject) => {
      socket.emit("agarrarItem", item, (response) => {
        console.log("agarrarItem response", response)
        resolve(response);
      });
    });

    console.log("agarrarItem response: ", responseMsg)
    return responseMsg;
  }

  function decir(texto) {

    let responseMsg = new Promise((resolve, reject) => {
      socket.emit("sendChatMessage", texto, (response) => {
        console.log("sendChatMessage response", response)
        resolve(response);
      });
    });

    return responseMsg;
  }

  function susurrar(idYtexto) {

    let responseMsg = new Promise((resolve, reject) => {
      socket.emit("susurrar", idYtexto, (response) => {
        console.log("susurrar response", response)
        resolve(response);
      });
    });

    return responseMsg;
  }

  function rol(texto) {

    let responseMsg = new Promise((resolve, reject) => {
      socket.emit("rol", texto, (response) => {
        console.log("rol response", response)
        resolve(response);
      });
    });

    return responseMsg;
  }

  function env(texto) {

    let responseMsg = new Promise((resolve, reject) => {
      socket.emit("env", texto, (response) => {
        console.log("env response", response)
        resolve(response);
      });
    });

    return responseMsg;
  }

  function sintonizar(frecuencia) {
    return new Promise((resolve) => {
      socket.emit("sintonizar", frecuencia, (response) => resolve(response));
    });
  }

  function radioTransmitir(texto) {
    return new Promise((resolve) => {
      socket.emit("radio", texto, (response) => resolve(response));
    });
  }

  function comer() {

    let responseMsg = new Promise((resolve, reject) => {
      socket.emit("comer", (response) => {
        console.log("comer response", response)
        resolve(response);
      });
    });

    return responseMsg;
  }

  function beber() {

    let responseMsg = new Promise((resolve, reject) => {
      socket.emit("beber", (response) => {
        console.log("beber response", response)
        resolve(response);
      });
    });

    return responseMsg;
  }

  function comandos() {
    return "\nComandos disponibles:\n\n(i)nspeccionar\n(n)orte / (s)ur / (e)ste / (o)este\n(m)apa\n\n(d)ecir MENSAJE\n(sus)urrar NOMBRE/JugadorID MENSAJE\nrol ACCIÓN\nenv DESCRIPCIÓN\ntimestamp\n\n(inv)entario\n(ag)arrar ITEM\n(guar)dar\n(sac)ar ITEM\ndar NOMBRE/JugadorID\ntirar\n\ncombate\n(sup)ervivencia\n\n(puer)ta\n(fab)ricar\n(gen)erador\ncofre\n\nsintonizar\n(r)adio\n\nonline\nexit\n\nEscribe el nombre del grupo para ver sus comandos." // - Deslizar (Celular)
  }

  function comandosPuerta() {
    return "\nComandos de puerta:\n\n(puer)ta (ab)rir/(ce)rrar/(for)zar DIRECCIÓN";
  }

  function comandosFabricar() {
    return "\nComandos de fabricar:\n\n(fab)ricar cofre";
  }

  function comandosGenerador() {
    return "\nComandos de generador:\n\n(gen)erador (col)ocar/(qui)tar/(pre)nder/(ap)agar/(rev)isar/(lle)nar";
  }

  function comandosCofre() {
    return "\nComandos de cofre:\n\ncofre CofreID (ab)rir/(ce)rrar CLAVE\ncofre CofreID (rev)isar/(guar)dar/(sac)ar/(for)zar";
  }

  function comandosCombate() {
    return "\nComandos de combate:\n\nretener NOMBRE/JugadorID\nliberar\ndisparar NOMBRE/JugadorID\nrevisar CadáverID\nquitar CadáverID OBJETO";
  }

  function comandosSupervivencia() {
    return "\nComandos de supervivencia:\n\ncomer\nbeber\nestado\nleer\nfumar\nhora";
  }

  function mapa() {

    let responseMsg = new Promise((resolve, reject) => {
      socket.emit("getMapWithCurrentLocation", (response) => {
        console.log("getMapWithCurrentLocation response", response)
        resolve(response);
      });
    });

    return responseMsg;
  }

  function guardarItem() {

    let responseMsg = "";
    responseMsg = new Promise((resolve, reject) => {
      socket.emit("guardarItem", (response) => {
        console.log("guardarItem response", response)
        resolve(response);
      });
    });

    console.log("guardarItem response: ", responseMsg)
    return responseMsg;
  }

  function tirarItem() {

    let responseMsg = "";
    responseMsg = new Promise((resolve, reject) => {
      socket.emit("tirarItem", (response) => {
        console.log("tirarItem response", response)
        resolve(response);
      });
    });

    console.log("tirarItem response: ", responseMsg)
    return responseMsg;
  }

  function sacarItem(item) {

    let responseMsg = "";
    responseMsg = new Promise((resolve, reject) => {
      socket.emit("sacarItem", item, (response) => {
        console.log("sacarItem response", response)
        resolve(response);
      });
    });

    console.log("sacarItem response: ", responseMsg)
    return responseMsg;
  }

  function darItem(id) {

    let responseMsg = "";
    responseMsg = new Promise((resolve, reject) => {
      socket.emit("darItem", id, (response) => {
        console.log("darItem response", response)
        resolve(response);
      });
    });

    console.log("darItem response: ", responseMsg)
    return responseMsg;
  }

  function retener(id) {

    let responseMsg = "";
    responseMsg = new Promise((resolve, reject) => {
      socket.emit("retener", id, (response) => {
        console.log("retener response", response)
        resolve(response);
      });
    });

    console.log("retener response: ", responseMsg)
    return responseMsg;
  }

  function liberar() {

    let responseMsg = "";
    responseMsg = new Promise((resolve, reject) => {
      socket.emit("liberar", (response) => {
        console.log("liberar response", response)
        resolve(response);
      });
    });

    console.log("liberar response: ", responseMsg)
    return responseMsg;
  }

  function disparar(id) {

    let responseMsg = "";
    responseMsg = new Promise((resolve, reject) => {
      socket.emit("disparar", id, (response) => {
        console.log("disparar response", response)
        resolve(response);
      });
    });

    console.log("disparar response: ", responseMsg)
    return responseMsg;
  }

  function estado() {

    let responseMsg = "";
    responseMsg = new Promise((resolve, reject) => {
      socket.emit("getStats", (response) => {
        console.log("getStats response", response)
        resolve(response);
      });
    });

    console.log("darItem response: ", responseMsg)
    return responseMsg;
  }

  function revisar(id) {

    let responseMsg = "";
    responseMsg = new Promise((resolve, reject) => {
      socket.emit("revisar", id, (response) => {
        console.log("revisar response", response)
        resolve(response);
      });
    });

    console.log("revisar response: ", responseMsg)
    return responseMsg;
  }

  function quitar(id) {

    let responseMsg = "";
    responseMsg = new Promise((resolve, reject) => {
      socket.emit("quitar", id, (response) => {
        console.log("quitar response", response)
        resolve(response);
      });
    });

    console.log("quitar response: ", responseMsg)
    return responseMsg;
  }

  function hora() {
    let responseMsg = new Promise((resolve, reject) => {
      socket.emit("hora", (response) => {
        console.log("hora response", response)
        resolve(response);
      });
    });

    return responseMsg;
  }

  function timestamp() {
    setTimestampActivado(!timestampActivado)
    sessionStorage.setItem('timestampActivado', (!timestampActivado).toString());
    var responseMsg = 'Timestamp ' + (!timestampActivado ? 'activado.' : 'desactivado.')
    return responseMsg;
  }

  function online() {
    let responseMsg = new Promise((resolve, reject) => {
      socket.emit("online", (response) => {
        console.log("online response", response)
        resolve(response);
      });
    });

    return responseMsg;
  }

  function puerta(comando) {

    let responseMsg = new Promise((resolve, reject) => {
      socket.emit("puerta", comando, (response) => {
        console.log("puerta response", response)
        resolve(response);
      });
    });

    return responseMsg;
  }

  function fabricar(objeto) {

    let responseMsg = new Promise((resolve, reject) => {
      socket.emit("fabricar", objeto, (response) => {
        console.log("fabricar response", response)
        resolve(response);
      });
    });

    return responseMsg;
  }

  function cofre(id) {

    let responseMsg = new Promise((resolve, reject) => {
      socket.emit("cofre", id, (response) => {
        console.log("cofre response", response)
        resolve(response);
      });
    });

    return responseMsg;
  }

  function login(params) {

    let responseMsg = new Promise((resolve, reject) => {
      socket.emit("login", params, (response) => {
        console.log("login response", response)
        resolve(response);
      });
    });

    return responseMsg;
  }

  function generador(comando) {
    let responseMsg = new Promise((resolve, reject) => {
      socket.emit("generador", comando, (response) => {
        console.log("generador response", response)
        resolve(response);
      });
    });

    return responseMsg;
  }

  function exit() {

    setLinesToPrint('Te desconectaste. Refrescá la página (F5) para entrar denuevo.');

    socket.disconnect(false, userID); // disconnectFromDeath = false

    setInputDisabled(true);

    return "Te desconectaste.";
  }

  function leer() {
    let responseMsg = new Promise((resolve, reject) => {
      socket.emit("leer", (response) => {
        console.log("leer response", response)
        resolve(response);
      });
    });

    return responseMsg;
  }

  function fumar() {
    return new Promise((resolve) => {
      socket.emit("fumar", (response) => resolve(response));
    });
  }

  // Comandos
  const commands = {

    // funcion comandos

    comandos: () => comandos(),
    comandosPuerta: () => comandosPuerta(),
    comandosFabricar: () => comandosFabricar(),
    comandosGenerador: () => comandosGenerador(),
    comandosCofre: () => comandosCofre(),
    combate: () => comandosCombate(),
    supervivencia: () => comandosSupervivencia(),

    decir: (texto) => decir(texto),
    d: (texto) => decir(texto),

    susurrar: (idYtexto) => susurrar(idYtexto),
    sus: (idYtexto) => susurrar(idYtexto),

    inspeccionar: () => inspeccionar(),
    inspec: () => inspeccionar(),
    ins: () => inspeccionar(),
    i: () => inspeccionar(),

    norte: () => resolverDireccion("norte"),
    sur: () => resolverDireccion("sur"),
    este: () => resolverDireccion("este"),
    oeste: () => resolverDireccion("oeste"),

    inventario: () => mostrarInventario(),
    inv: () => mostrarInventario(),

    sacar: (item) => sacarItem(item),
    guardar: () => guardarItem(),
    // usar: () => usarItem(),
    dar: (id) => darItem(id),
    tirar: () => tirarItem(),

    agarrar: (item) => agarrarItem(item),
    ag: (item) => agarrarItem(item),

    retener: (id) => retener(id),
    liberar: () => liberar(),
    disparar: (id) => disparar(id),

    comer: () => comer(),
    beber: () => beber(),

    estado: () => estado(),

    mapa: () => mapa(), // Agregar mapa a inventario y *usar*

    revisar: (id) => revisar(id),
    quitar: (id) => quitar(id),

    rol: (texto) => rol(texto),
    env: (texto) => env(texto),

    sintonizar: (frecuencia) => sintonizar(frecuencia),
    radio: (texto) => radioTransmitir(texto),
    r: (texto) => radioTransmitir(texto),

    hora: () => hora(), // Agregar necesidad de item reloj

    online: () => online(),

    timestamp: () => timestamp(),

    puerta: (comando) => puerta(comando),

    fabricar: (objeto) => fabricar(objeto),
    cofre: (id) => cofre(id),

    login: (params) => login(params),

    generador: (comando) => generador(comando),

    exit: () => exit(),

    leer: () => leer(),

    fumar: () => fumar(),

  };

  return (
    // <div style={{overscrollBehavior: "none"}} onTouchStart={onTouchStart} onTouchMove={onTouchMove} onTouchEnd={onTouchEnd}>

    <div>
      <CustomTerminal
        disabled={inputDisabled}
        handleCommands={commands}
        input={input}
        setInput={setInput}
        id={userID ? " (ID "+userID+")" : ""}
        inputLabel={nombreJugador ? nombreJugador : ""}
        linesToPrint={linesToPrint}
        setLinesToPrint={setLinesToPrint}
        timestampActivado={sessionStorage.getItem('timestampActivado') === "true"}
      // onBlur={zoomOutMobile}
      />
    </div>
  );
}